export const getTrustpilotUrl = (
  languageCode: string | undefined,
  reviewSlug = 'rover.com'
): URL => {
  if (!languageCode) return new URL(`https://trustpilot.com/review/${reviewSlug}?languages=all`);
  switch (languageCode) {
    case 'fr-ca':
      return new URL(`https://fr.trustpilot.com/review/${reviewSlug}?languages=all`);
    case 'en-gb':
      return new URL(`https://uk.trustpilot.com/review/${reviewSlug}?languages=all`);
    default:
      return new URL(
        `https://${languageCode?.split('-')[1]}.trustpilot.com/review/${reviewSlug}?languages=all`
      );
  }
};

export default getTrustpilotUrl;
